import { ref } from "vue";
import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", () => {
  const credentials = ref({ email: "", password: "" });

  const newPassword = ref({token:"",email:"",password:"",password_confirmation:""});

  const currentUser = ref(null);

  const avatar = ref();

  const setCurrentUser = (user) => (currentUser.value = user);
  const setNewPassword = (newPassword) => {
    newPassword.value = { ...newPassword };
  };

  return {
    //* States
    credentials,
    newPassword,
    currentUser,
    avatar,
    //* Methos
    setCurrentUser,
    setNewPassword
  };
});
